import { useState } from 'react';
import {
  Overlay,
  StyledModal,
  ModalHeader,
  ModalTitle,
  CloseButton,
  SaveButton,
} from '../styles/StyledPresetModal';
import LabeledInput from './LabeledInput';

interface CubicBezNotationModalProps {
    displayValue: string;
    handleApplyCubicBezierNotation: (cubicBezierNotation: string) => void;
  }
  
  export function CubicBezNotationModal({ displayValue, handleApplyCubicBezierNotation }: CubicBezNotationModalProps) {
    const [cubicBezNotation, setCubicBezNotation] = useState<string>(displayValue);
  
    return (
      <Overlay>
        <StyledModal>
          <ModalHeader>
              <ModalTitle>cubic-bezier notation</ModalTitle>
              <CloseButton onClick={() => handleApplyCubicBezierNotation('')}>&#x2716;</CloseButton>
          </ModalHeader>
          <LabeledInput
              label="accepts 4 comma separated values"
              value={cubicBezNotation}
              onChange={(e) => setCubicBezNotation(e.target.value)}
              isVisible={true}
              type="text"
          />
          <SaveButton type="button" onClick={() => handleApplyCubicBezierNotation(cubicBezNotation)}>
              Apply
          </SaveButton>
        </StyledModal>
      </Overlay>
    );
  }